import { useEffect, useState } from "react";
import TodayIcon from "@mui/icons-material/Today";
import edit from "../../assets/orders/editorder.svg";
import schedule from "../../assets/orders/clock.svg";
import prescription from "../../assets/tasks/Noteform.svg";
import addicon from "../../assets/orders/carbon_add.svg";
import ArticleIcon from "@mui/icons-material/Article";
import { Backdrop, CircularProgress, Switch } from "@mui/material";
import NavButtons from "../nav/navbuttons";
import EditPopup from "../popups/editpopup";
import AddNotesPopup from "../popups/addnotes";
import NewRxPopup from "../popups/newrx";
import api from "../../api/api";
import { useNavigate, useParams } from "react-router-dom";
import LabsNavButtons from "../nav/labsbuttons";
import ProceduresNavButtons from "../nav/procedurebuttons";
import { useDispatch, useSelector } from "react-redux";
import { setSearchResults } from "../../reduxtoolkit/orders/universalsearch";
import ToastMessage from "../../utils/mui/righttoptoast";
import Schedularpopup from "../popups/schedular";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarDays } from "@fortawesome/free-solid-svg-icons";
import calender from "../../../src/assets/orders/calender.svg";
import AddNoteData from "../../assets/tasks/NoteData.svg";
import { updatelovValue, updateTovValue } from "../../reduxtoolkit/dump";
import {
  collapseIcon,
  expandIcon,
  notesIcon,
  pendingIcon,
  penIcon,
  prescriptionIcon,
  RXIcon,
  scheduledIcon,
  todayIcon,
} from "./svg";
import { COMPLETEDIcon, CROSSIcon } from "../../landingscreen/modals/svgs";
import VitaminsNavButtons from "../nav/vitaminButtons";
import dayjs from "dayjs";
const VitaminTab = ({
  data,
  appointmentId,
  setShowOrders,
  selectedSuggestionList,
  getordersData,
  referals,
  startDate,
  suggestionData,
  fetchsuggestions,
  selectedCard,
  SetSelectedCard,
}) => {
  const [isActive, setIsActive] = useState(false);
  const practiseid = window.getPracticeId();
  const [activeButton, setActiveButton] = useState(3);
  const [alertmessage, setAlertMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [selectedButtons, setSelectedButtons] = useState([]);
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [isEditPopupOpen, setIsEditPopupOpen] = useState(false);
  const [selectedEdit, setSelectedEdit] = useState("t");
  // const [selectedSuggestionList,setSelectedSuggestionList]=useState([])
  // const [suggestionData,setSuggestionsData]=useState([])
  const [isSchedularpopup, setIsSchedularPopUp] = useState(false);
  // const [getordersData,setGetOrdersData]=useState([])
  // const [referals,setReferals]=useState([])
  const dispatch = useDispatch();
  const [isAddnotesPopup, setAddNotesPopup] = useState(false);
  // const [selectedCard,SetSelectedCard]=useState('f')
const params = useParams();

const id = params.id || appointmentId;
const dt = params.dt || startDate;
  const [loading, setLoading] = useState(false);
  const lovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov")?.value
  );
  const userConfig = useSelector((state) => state.userconfig);
  const tovValue = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov")?.value
  );
  const lov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "lov2")?.value
  );
  const tov2Value = useSelector(
    (state) => state.dump.storedvalues.find((item) => item.id === "tov2")?.value
  );
  const [isnewRxpopup, setNewRxPopup] = useState(false);
  const searchResults = useSelector(
    (state) => state.universalsearcher.searchResults
  );
  const [expandedCards, setExpandedCards] = useState({
    today: false,
    scheduled: false,
    prescriptions: false,
    notes: false,
  });

  const toggleCardExpansion = (cardName) => {
    setExpandedCards((prev) => ({
      ...prev,
      [cardName]: !prev[cardName],
    }));
  };

  // Badge count logic
  const todayItems = [
    ...(selectedSuggestionList?.filter((d) => d.schedule === "f") ?? []),
    ...(referals ?? []),
  ];

  // Which statuses count as inactive
  const completedOrCancelled = ["COMPLETED", "CANCELLEDTASK"];

  // Are ALL items inactive?
  const allInactive =
    todayItems.length > 0 &&
    todayItems.every((item) =>
      completedOrCancelled.includes(String(item?.status).toUpperCase())
    );

  // Pending = not completed/cancelled
  const pendingItems = todayItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())&&item.context!== "Tov"
  );

  // Decide the badge number
  const badgeCount = allInactive ? todayItems.length : pendingItems.length;

  // Scheduled items logic
  const scheduledItems =
    selectedSuggestionList?.filter((d) => d.schedule === "t") ?? [];
  const scheduledCompletedOrCancelled = scheduledItems.every((item) =>
    completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledPendingItems = scheduledItems.filter(
    (item) => !completedOrCancelled.includes(String(item?.status).toUpperCase())
  );
  const scheduledBadgeCount =
    scheduledCompletedOrCancelled && scheduledItems.length > 0
      ? scheduledItems.length
      : scheduledPendingItems.length;

  // Prescriptions items logic
  const prescriptionItems = getordersData?.rx_recipe ?? [];
  const prescriptionBadgeCount = prescriptionItems.length; // Prescriptions don't have status, so show all

  // Notes items logic
  const notesItems = getordersData?.notes ?? [];
  const notesBadgeCount = notesItems.length; // Notes don't have status, so show all

  const editalert = (text, sev) => {
    setIsEditPopupOpen(false);
    setSeverity(sev);
    setAlertMessage(text);
    setOpen(true);
    fetchsuggestions();
  };
  const handlealert = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  useEffect(() => {
    fetchsuggestions();
  }, [dt]);

  const handleClose = async () => {
    try {
      setLoading(true);
      const response = await api.delete(
        `/v1/${practiseid}/orders/delete/patient/${data.patientid}/notconfirmed`,
        {
          data: {
            // orderdate: data.created_at?new Date(data.created_at).toISOString().split('T')[0]: "Invalid date",
            orderdate:
              dt && dt.includes(" ") && !isNaN(Date.parse(dt.split(" ")[0]))
                ? dt.split(" ")[0]
                : new Date().toISOString().split("T")[0],
          },
        }
      );
      setTimeout(() => {
        if (appointmentId) {
          dispatch(updatelovValue(data.lov));
          dispatch(updateTovValue(data.tov));
          setShowOrders(false);
        } else {
          navigate("/landing");
        }
      }, 2000);
    
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      fetchsuggestions();
    }
  };
  const selectsuggestion = async (order) => {
    setLoading(true);
    try {
      const createResponse = await api.post(
        `/v1/${practiseid}/patient/${data.patientid}/orders/create`,
        {
          department_id: 1,
          patient_name: `${data.firstname || ""} ${data.lastname || ""}`.trim(),
          tov: tovValue, // purpose
          lov: lovValue,
          diagnosis: "",
          // ordertype: "vitamin", // tabs
              ordertype: order.context=='diagnosis'?'Diagnostic Tests':order.context, // tabs
          ordername:order.content, // buttons
          schedule: selectedCard, // t/f-schedule
          // provider: data.linked_provider,
          provider: `${userConfig?.firstname || ""} ${userConfig?.lastname || ""}`,
          status: "CREATED",
          confirm_status: "E", // C/E
          // orderdate:  userdata.created_at?new Date(userdata.created_at).toISOString().split('T')[0]: "Invalid date",
            orderdate: dayjs(dt).isValid()
           ? dayjs(dt).format("YYYY-MM-DD")
           : dayjs().format("YYYY-MM-DD"),
          encounterid: 0,
        }
      );
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
      dispatch(setSearchResults([]));
      fetchsuggestions();
    }
  };
 
  return (
    <>
      <VitaminsNavButtons
        selectedCard={selectedCard}
        userdata={data}
        data={suggestionData}
        selectedSuggestionList={selectedSuggestionList}
        fetchsuggestions={fetchsuggestions}
        loading={loading}
        getordersData={getordersData}
              dt={dt}
      />

      {searchResults.length ? (
        <div className="text-start m-2 text-sm text-[#7e7e7e] text-[13px]">
          Search Suggestions
        </div>
      ) : (
        <></>
      )}
      <div className="flex flex-wrap gap-2">
        {searchResults.map((result) => {
          const isSelected = selectedButtons.includes(result.id);

          return (
            <button
              key={result.id}
              className={`px-6 py-1 cursor-pointer text-xs font-poppins tracking-tight font-thin text-center rounded border-[1px] border-gray-200 flex items-center justify-center transition-colors duration-300 ease-in-out ${
                isSelected
                  ? "bg-[#e17954] text-white"
                  : "bg-white text-[#1D2951]"
              }`}
              onClick={() => selectsuggestion(result)}
            >
              {result.content}
              <span
                className="ml-2 px-2 py-[2px] text-xs font-semibold rounded"
                style={{
                  backgroundColor: isSelected ? "#1E2A4A" : "#1E2A4A", // Light orange or gray depending on selection
                  color: isSelected ? "white" : "white", // Adjust text color based on selection
                }}
              >
               {result.context=='diagnosis'?'Diagnostic Tests':result.context}
              </span>
            </button>
          );
        })}
      </div>

      <div className="flex flex-wrap justify-center gap-8 m-4 mt-4">
        {/* Card 1 - Today */}
        <div
          onClick={(event) => {
            event.stopPropagation();
            SetSelectedCard("f");
          }}
          className={`w-[500px] flex flex-col items-start p-3 bg-white rounded-[8px] shadow-md
              transition-all duration-300 ease-in-out
              ${
                expandedCards.today ? "max-h-[80vh]" : "h-[280px] min-h-[280px]"
              }`}
          style={{
            boxShadow:
              selectedCard === "f" ? "0px 0px 10px rgba(0, 0, 0, 0.8)" : "",
          }}
        >
          {/* header */}
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{todayIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                Today
              </span>
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-full text-white text-sm ${
                  allInactive ? "bg-gray-500" : "bg-[#E17954]"
                }`}
              >
                {badgeCount}
              </div>
            </div>

            <div className="w-full flex justify-end">
              <div
                className="cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  setSelectedEdit("f");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />

          {/* list */}
          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.today ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.today ? "max-h-none" : "max-h-[240px]"}`}
          >
            {selectedSuggestionList?.filter((d) => d.schedule === "f"&&d.context!== "Tov").length >
              0 || referals?.length > 0 ? (
              [
                ...selectedSuggestionList.filter((d) => d.schedule === "f"&&d.context!== "Tov"),
                ...referals,
              ]
                .sort((a, b) => {
                  const order = { CREATED: 1, COMPLETED: 2, CANCELLEDTASK: 3 };
                  return (order[a.status] || 4) - (order[b.status] || 4);
                })
                // .slice(0, expandedCards.today ? undefined : 3)
                .map((data, index) => (
                  <div
                    key={index}
                    className={`w-full my-2 ${
                      data?.status === "CANCELLEDTASK" ||
                      data?.status === "COMPLETED"
                        ? "opacity-[50%]"
                        : "opacity-100"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {/* icon */}
                      <div className="shrink-0  mt-[2px]">
                        {data?.status == "CANCELLEDTASK"
                          ? CROSSIcon
                          : data?.status == "COMPLETED"
                          ? COMPLETEDIcon
                          : pendingIcon}
                      </div>

                      {/* text block */}
                      <div className="flex flex-col text-left">
                        <span className="text-[12px] font-inter uppercase font-semibold tracking-wide text-[#000000]">
                          {data?.context === "Diagnosis"
                            ? "Diagnostic test"
                            : data?.context || "referrals"}
                        </span>
                        <span className="text-[14px] font-inter text-[#111827]">
                          {data.ordername}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No Today appointments!
              </div>
            )}
          </div>

          {/* expand / collapse button (bottom-right) */}
          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("today");
            }}
            aria-label={expandedCards.today ? "Collapse" : "Expand"}
            title={expandedCards.today ? "Collapse" : "Expand"}
          >
             <span
                          className={`inline-block transition-transform duration-200 `}
                        >
                          { expandedCards.today?collapseIcon:expandIcon}
                        </span>
          </button>
        </div>

        {/* Card 2 - Scheduled */}
        <div
          onClick={(event) => {
            event.stopPropagation();
            SetSelectedCard("t");
          }}
          className={`w-[500px] flex flex-col items-start p-3 bg-white shadow-md rounded-[8px]
              transition-all duration-300 ease-in-out
              ${
                expandedCards.scheduled
                  ? "max-h-[80vh]"
                  : "h-[280px] min-h-[280px]"
              }`}
          style={{
            boxShadow: selectedCard === "t" ? "0px 0px 10px #E17954CC" : "",
          }}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{scheduledIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                Scheduled
              </span>
              <div
                className={`w-6 h-6 flex items-center justify-center rounded-full text-white text-sm ${
                  scheduledCompletedOrCancelled && scheduledItems.length > 0
                    ? "bg-gray-500"
                    : "bg-[#E17954]"
                }`}
              >
                {scheduledBadgeCount}
              </div>
            </div>

            <div className="w-full flex justify-end">
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEdit("t");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />

          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.scheduled ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.scheduled ? "max-h-none" : "max-h-[240px]"}`}
          >
            {selectedSuggestionList?.filter((data) => data.schedule === "t")
              .length > 0 ? (
              selectedSuggestionList
                ?.filter((data) => data.schedule === "t")
                .sort((a, b) => {
                  const order = { CREATED: 1, COMPLETED: 2, CANCELLEDTASK: 3 };
                  return (order[a.status] || 4) - (order[b.status] || 4);
                })
                // .slice(0, expandedCards.scheduled ? undefined : 3)
                .map((data, index) => (
                  <div
                    key={index}
                    className={`w-full my-2 ${
                      data?.status === "CANCELLEDTASK" ||
                      data?.status === "COMPLETED"
                        ? "opacity-[50%]"
                        : "opacity-100"
                    }`}
                  >
                    <div className="flex items-center gap-3">
                      {/* icon */}
                      <div className="shrink-0  mt-[2px]">
                        {data?.status == "CANCELLEDTASK"
                          ? CROSSIcon
                          : data?.status == "COMPLETED"
                          ? COMPLETEDIcon
                          : pendingIcon}
                      </div>

                      {/* text block */}
                      <div className="w-full flex flex-col text-left">
                        <span className="text-[12px] font-inter uppercase font-semibold tracking-wide text-[#000000]">
                           {data?.context === "Diagnosis"
                            ? "Diagnostic test"
                            : data?.context || "referrals"}
                        </span>
                        <span className="flex justify-between w-full text-[14px] font-inter text-[#111827]">
                          {data.ordername}
                          {data.context === "Procedure" && (
                            <img
                              className="mb-1 ml-1 inline"
                              src={calender}
                              style={{ width: "15px", cursor: "pointer" }}
                              onClick={() => setIsSchedularPopUp(true)}
                              alt="calendar"
                            />
                          )}
                        </span>
                      </div>
                    </div>
                  </div>
                ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No upcoming appointments!
              </div>
            )}
          </div>

          {/* expand / collapse button (bottom-right) */}
          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("scheduled");
            }}
            aria-label={expandedCards.scheduled ? "Collapse" : "Expand"}
            title={expandedCards.scheduled ? "Collapse" : "Expand"}
          >
            <span
                                  className={`inline-block transition-transform duration-200 `}
                                >
                                  {   expandedCards.scheduled ?collapseIcon:expandIcon}
                                </span>
          </button>
        </div>

        {/* Card 3 - Prescriptions */}
        <div
          className={`w-[500px] flex flex-col items-start p-3 bg-white rounded-[8px] shadow-md
              transition-all duration-300 ease-in-out
              ${
                expandedCards.prescriptions
                  ? "max-h-[80vh]"
                  : "h-[280px] min-h-[280px]"
              }`}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{prescriptionIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                PRESCRIPTIONS
              </span>
              <div className="w-6 h-6 flex items-center justify-center bg-[#E17954] rounded-full text-white text-sm">
                {prescriptionBadgeCount}
              </div>
            </div>

            <div className="w-full flex gap-2 justify-end">
              <div
                className="cursor-pointer"
                onClick={() => setNewRxPopup(true)}
              >
                {RXIcon}
              </div>
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEdit("");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />
          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.prescriptions ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.prescriptions ? "max-h-none" : "max-h-[240px]"}`}
          >
            {getordersData?.rx_recipe?.length > 0 ? (
              getordersData?.rx_recipe?.map((data, index) => (
                <div key={index} className="w-full my-2">
                  <div className="flex items-center gap-3">
                    {/* icon */}
                    <div className="shrink-0  mt-[2px]">{COMPLETEDIcon}</div>

                    {/* text block */}
                    <div className="flex flex-col text-left">
                      <span className="text-[12px] font-inter uppercase font-semibold tracking-wide text-[#000000]">
                        PRESCRIPTIONS
                      </span>
                      <span className="text-[14px] font-inter text-[#111827]">
                        {data.medicationname} -{" "}
                        {`${data.dosage_qty} ${data.dosage_qty_unit} ${data.frequency} ${data.duration}`}
                      </span>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No active prescriptions!
              </div>
            )}
          </div>

          {/* expand / collapse button (bottom-right) */}
          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("prescriptions");
            }}
            aria-label={expandedCards.prescriptions ? "Collapse" : "Expand"}
            title={expandedCards.prescriptions ? "Collapse" : "Expand"}
          >
               <span
                        className={`inline-block transition-transform duration-200 `}
                      >
                        {   expandedCards.prescriptions  ?collapseIcon:expandIcon}
                      </span>
          </button>
        </div>

        {/* Card 4 - Notes */}
        <div
          className={`w-[500px] flex flex-col items-start p-3 bg-white rounded-[8px] shadow-md
              transition-all duration-300 ease-in-out
              ${
                expandedCards.notes ? "max-h-[80vh]" : "h-[280px] min-h-[280px]"
              }`}
        >
          <div className="flex justify-between w-full mb-2">
            <div className="flex items-center mx-1.5">
              <div className="text-[#000000]">{notesIcon}</div>
              <span className="mx-2 text-[16px] font-medium font-inter text-[#101828]">
                NOTES
              </span>
              <div className="w-6 h-6 flex items-center justify-center bg-[#E17954] rounded-full text-white text-sm">
                {notesBadgeCount}
              </div>
            </div>

            <div className="w-full flex gap-2 justify-end">
              <div
                className="cursor-pointer"
                onClick={() => setAddNotesPopup(true)}
              >
                {RXIcon}
              </div>
              <div
                className="cursor-pointer"
                onClick={() => {
                  setSelectedEdit("");
                  setIsEditPopupOpen(true);
                }}
              >
                {penIcon}
              </div>
            </div>
          </div>

          <div className="h-[1px] w-[85%] bg-gray-200 self-center mt-2" />

          <div
            className={`flex flex-col w-full px-3 mt-2 flex-grow
      ${expandedCards.notes ? "overflow-visible" : "thin-visible-scrollbar"}
      ${expandedCards.notes ? "max-h-none" : "max-h-[240px]"}`}
          >
            {getordersData?.notes?.length > 0 ? (
              getordersData?.notes?.map((data, index) => (
                <div key={index} className="w-full my-2">
                  <div className="flex flex-col text-left">
                    <span className="text-[14px] font-inter text-[#111827]">
                      {data.ordername}
                    </span>
                    {/* <span className="text-[12px] font-inter text-[#71717A] mt-1">
                      Dr. Smith
                    </span> */}
                  </div>
                </div>
              ))
            ) : (
              <div className="w-full text-center text-[#4B5563] text-[12px]">
                No notes available!
              </div>
            )}
          </div>

          {/* expand / collapse button (bottom-right) */}
          <button
            className="ml-auto rounded hover:bg-gray-50 transition
               flex items-center justify-center focus:outline-none"
            onClick={(e) => {
              e.stopPropagation();
              toggleCardExpansion("notes");
            }}
            aria-label={expandedCards.notes ? "Collapse" : "Expand"}
            title={expandedCards.notes ? "Collapse" : "Expand"}
          >
           
                           <span
                                   className={`inline-block transition-transform duration-200 `}
                                 >
                                   {   expandedCards.notes ?collapseIcon:expandIcon}
                                 </span>
          </button>
        </div>
      </div>

      {/* <div className="w-full flex justify-end gap-4 sm:gap-4 mt-4">

                    <button
                    onClick={()=>handleClose()}
                        className="rounded w-[100px] bg-white cursor-pointer text-black border-[1.5px] border-gray-200 py-1 px-3 transition duration-300 ease-in-out  hover:bg-gray-800">
                        Close
                    </button>

                    <button
onClick={()=>handleSave()}
                        className="rounded w-[100px] bg-black text-white py-1 px-3 bg-[#1E2A4A] transition duration-300 ease-in-out hover:bg-gray-800">
                        Save
                    </button>
                </div> */}
      <EditPopup
        fetchsuggestions={fetchsuggestions}
        selectedEdit={selectedEdit}
        editalert={editalert}
        isOpen={isEditPopupOpen}
        onClose={() => setIsEditPopupOpen(false)}
        getordersData={getordersData}
              dt={dt}
      />
      <AddNotesPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        isOpen={isAddnotesPopup}
        onClose={() => setAddNotesPopup(false)}
              dt={dt}
      />
      <NewRxPopup
        fetchsuggestions={fetchsuggestions}
        userdata={data}
        isOpen={isnewRxpopup}
        onClose={() => setNewRxPopup(false)}
  dt={dt}
      />
      <Schedularpopup
        isOpen={isSchedularpopup}
        onClose={setIsSchedularPopUp}
        data={data}
      />
      <Backdrop
        sx={{
          color: "secondary.main", // Sets the CircularProgress color to secondary
          backgroundColor: "rgba(255, 255, 255, 0.5)", // Semi-transparent white background
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
        open={loading}
      >
        <CircularProgress color="secondary" />
      </Backdrop>
      <ToastMessage
        message={alertmessage}
        severity={severity}
        open={open}
        handleClose={handlealert}
      />
    </>
  );
};
export default VitaminTab;
